import { ReactNode } from 'react';
import './AstraWelcome.css';

export interface AstraWelcomeProps {
    droneCount: number;
}

function AstraWelcome({ droneCount }: AstraWelcomeProps): ReactNode {
    return (
        <div className='astra-welcome'>
            <div>Вся информация о подключениях и актуальные версии прошивки в <a href='https://wiki.csky.space/wiki/astra/manual'>WIKI.</a></div>
            {droneCount <= 0 &&
                <div>Заметил, что у тебя еще нет устройств, инструкция по сборке и подписка находятся по <a href='https://csky.space/astra'>ссылке</a></div>
            }
        </div>
    )
}

export default AstraWelcome;